import { render } from "./SmartsheetSidebar.vue?vue&type=template&id=60f9cd84&scoped=true"
import script from "./SmartsheetSidebar.vue?vue&type=script&lang=js"
export * from "./SmartsheetSidebar.vue?vue&type=script&lang=js"

import "./SmartsheetSidebar.vue?vue&type=style&index=0&id=60f9cd84&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f9cd84"]])

export default __exports__